export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9408WQHD_white-b526ebb3e59e9a1b8c97e90d99711028.webp";